<form #editOfficeForm="ngForm">
    <div class="modal-header">
      <h4>Edit office</h4>
      <i class="d-flex justify-content-end icon-ic_delete px-2" (click)="modalRef.hide()" style="cursor: pointer;margin-top: 8px;"></i>
    </div>
    <div class="modal-body">
      <div class="form-group mt-4">
        <strong>Country</strong>
        <input type="text" autocomplete="off" name="country" class="form-control mt-2" #country="ngModel" id="country"
        placeholder="Enter country name" [(ngModel)]="CountryName"  readonly>
        <div *ngIf="country.invalid && (country.dirty || country.touched)" class="alert alert-danger">
          <div class="mt-2" *ngIf="country.errors.required">
            country is required.
          </div>
        </div>
      </div>
      <div class="form-group mt-4">
        <strong>City</strong>
        <input type="text" autocomplete="off" name="city" class="form-control mt-2" #city="ngModel" id="city"
        placeholder="Enter city name" [(ngModel)]="CityName"  readonly>
        <div *ngIf="city.invalid && (city.dirty || city.touched)" class="alert alert-danger">
          <div class="mt-2" *ngIf="city.errors.required">
            City is required.
          </div>
        </div>
      </div>
    
  
    <div class="from-group mt-4">
      <strong>Office</strong>
      <input type="text" autocomplete="off" name="office" class="form-control mt-2" #office="ngModel" id="office"
        placeholder="Enter office name" [(ngModel)]="OfficeName">
      <div *ngIf="office.invalid && (office.dirty || office.touched)" class="alert alert-danger">
        <div class="mt-2" *ngIf="office.errors.required">
          Office is required.
        </div>
      </div>
    </div>
    <div class="from-group mt-4">
      <strong>Address</strong>
      <input type="text" autocomplete="off" class="form-control mt-2"  name="address" [(ngModel)]="OfficeAddress" id="address" placeholder="Enter office address" ngModel required>
      <!--<div *ngIf="office.invalid && (office.dirty || office.touched)" class="alert alert-danger">
        <div class="mt-2" *ngIf="office.errors.required" >
          Office is required.
        </div>
      </div>-->
  </div>
    <div class="form-group mt-4">
      <strong>Status</strong>
      <span class="icon-radiobutton_active mr-2" *ngIf="selectActiveStatus.isChecked"
        (click)="selectActiveStatus.isChecked = true"></span>
      <span class="icon-radiobutton_inactive mr-2" *ngIf="!selectActiveStatus.isChecked"
        (click)="selectInActiveStatus.isChecked = false ; selectActiveStatus.isChecked = true"></span>
      <span class="mr-3">Active</span>
      <span class="icon-radiobutton_active mr-2" *ngIf="selectInActiveStatus.isChecked"
        (click)="selectInActiveStatus.isChecked = true"></span>
      <span class="icon-radiobutton_inactive mr-2" *ngIf="!selectInActiveStatus.isChecked"
        (click)="selectInActiveStatus.isChecked = true ; selectActiveStatus.isChecked = false"></span>
      <span>Inactive</span>
    </div>
    </div>
  
    <div class="modal-footer">
      <button (click)="modalRef.hide()" type="button" class="button">
        Cancel
      </button>
      <button [disabled]="this.showBtn()" (click)="EditOffice(office.value)"
        class="button blue" type="button">
        Save
      </button>
    </div>
  </form>

  